import { render, staticRenderFns } from "./CourseOrderDetail.vue?vue&type=template&id=e8098dde&scoped=true&"
import script from "./CourseOrderDetail.vue?vue&type=script&lang=js&"
export * from "./CourseOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseOrderDetail.vue?vue&type=style&index=0&id=e8098dde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8098dde",
  null
  
)

export default component.exports